import { render, staticRenderFns } from "./mediaLinksItem.vue?vue&type=template&id=18a81fb6&scoped=true"
import script from "./mediaLinksItem.vue?vue&type=script&lang=js"
export * from "./mediaLinksItem.vue?vue&type=script&lang=js"
import style0 from "./mediaLinksItem.vue?vue&type=style&index=0&id=18a81fb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a81fb6",
  null
  
)

export default component.exports